const sportsTypes = [
  { id: 1, label: 'tennis' },
  { id: 2, label: 'golf' },
  { id: 3, label: 'paddle' },
];

export default sportsTypes;
